import { moveAxisRange, rotateAxisRange, moveAxis } from '../../../utils/moveObjects'
import { useFrame } from "@react-three/fiber"
import { useEffect, useRef } from "react"
import { useActsStore } from "../../../store/useActsStore"


export default function Cockpit (props) {
    const cockpit = useRef()

    const cockPitStartPosition = [-4.55, -0.1, -4]

    
    useFrame((_,delta) => {
        const stateActe = useActsStore.getState()
        const id = stateActe.getCurrentActId()

        const holdProgress = stateActe.actsProgress[id]?.holdProgress ?? 0
         
        
        if(id ===1) {
            if (!cockpit.current) return
            moveAxisRange(
                cockpit,
                'x',
                cockPitStartPosition[0],
                2.55,
                holdProgress,
                0.0,
                0.15,
                1, 
                delta
            )
            moveAxisRange(
                cockpit,
                'y',
                cockPitStartPosition[1],
                -1.3,
                holdProgress,
                0.12,
                0.15,
                1, 
                delta
            )
            // moveAxisRange(
            //     cockpit,
            //     'z',
            //     cockPitStartPosition[2],
            //    -0.25,
            //     holdProgress,
            //     0.12,
            //     0.15
            // )
        }
    })

    return <>
        <mesh
            {...props}
            position={cockPitStartPosition}
            castShadow
            ref={cockpit}
        >
            <sphereGeometry args={[0.03, 32, 32]} />
            <meshPhysicalMaterial
                roughness={0}
                metalness={0}
                thickness={0.2}
                transmission={0.9}
                attenuationDistance={0.45}
                ior={1.05}
                clearcoat={1.5}
                clearcoatRoughness={0.05}
                dispersion={1}
            />
        </mesh>
    </>
}